import { styled } from 'styled-components';

interface ReSendCodeDivProps {
  $pointer?: boolean;
}

export const ReSendCodeWrap = styled.div`
  text-align: center;
  margin-top: 40px;
  color: var(--pcm-body-color-secondary);
  font-size: 14px;
`;

export const ReSendCodeDiv = styled.div<ReSendCodeDivProps>`
  color: var(--pcm-accent-color);
  margin-top: 6px;
  cursor: ${({ $pointer }) => ($pointer ? 'pointer' : 'default')};
  display: flex;
  gap: 0px;
  align-items: center;
  width: 100%;
  justify-content: center;
  position: relative;
  height: 24px;
`;
